/**
 * Returns the visible REFERRAL_SOURCE related case, if one exists.
 */
export const getReferralSourceRelatedCase = (relatedCases?: Maybe<RelatedCase[]>) =>
  relatedCases?.find((rc) => rc.relationship_type === 'REFERRAL_SOURCE')

/**
 * Returns true if the case was received as a referral from another broker
 * (i.e. has a visible REFERRAL_SOURCE related case).
 */
export const isReferralCase = (relatedCases?: Maybe<RelatedCase[]>) =>
  Boolean(getReferralSourceRelatedCase(relatedCases))

/**
 * Returns true if the case was referred from an external organisation
 * (neither firm_id nor representative_of on the referral source matches the current user's org).
 *
 * Pass `currentOrgId` from `useUserContext()?.organisation?.id`.
 */
export const isOrgToOrgReferral = (
  relatedCases: Maybe<RelatedCase[]> | undefined,
  currentOrgId: Maybe<string> | undefined,
): boolean => {
  const referralSource = getReferralSourceRelatedCase(relatedCases)

  if (!referralSource) return false
  if (!currentOrgId) return true

  return referralSource.firm_id !== currentOrgId && referralSource.representative_of !== currentOrgId
}

/**
 * Returns true if the case was referred from within the current user's own organisation network
 * (firm_id or representative_of on the referral source matches the current user's org).
 *
 * Pass `currentOrgId` from `useUserContext()?.organisation?.id`.
 */
export const isWithinNetworkReferral = (
  relatedCases: Maybe<RelatedCase[]> | undefined,
  currentOrgId: Maybe<string> | undefined,
): boolean => {
  const referralSource = getReferralSourceRelatedCase(relatedCases)
  if (!referralSource) return false
  if (!currentOrgId) return false

  return referralSource.firm_id === currentOrgId || referralSource.representative_of === currentOrgId
}
